/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue";
import Scroll from '@/components/Base/Scroll/indexBeta';
import { getExitDrawing, getHdProjectproductGetScrapFile, getHdProjectproductGetOperateVideo } from '@/api';
export default {
  name: 'Information',
  components: {
    SmyTab: function SmyTab() {
      return import('@/components/SmyTab');
    },
    ViewBox: ViewBox,
    Scroll: Scroll
  },
  data: function data() {
    return {
      infoContent: '',
      order_state: 1,
      searchForm: {
        pageNo: 0,
        pageSize: 10,
        code: this.$router.currentRoute.params.code,
        type: ''
      },
      dataList: [],
      dataList1: [],
      fileList: [],
      videoList: [],
      searchForm2: {
        pageNo: 0,
        pageSize: 10,
        code: this.$router.currentRoute.params.code
      }
    };
  },
  computed: {
    tabList: function tabList() {
      var tabList = [{
        name: '出厂图纸',
        value: 1
      }, {
        name: '出厂报告',
        value: 2
      }, {
        name: '产品手册',
        value: 3
      }];

      if (this.videoList.length) {
        tabList.push({
          name: '操作视频',
          value: 4
        });
      }

      tabList.push({
        name: '报废拆解方案',
        value: 5
      });
      return tabList;
    }
  },
  methods: {
    download: function download(res) {
      console.log(res);
      window.open(res, '_blank');
    },
    loadList: function loadList() {
      var _this = this;

      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (reset) {
        this.searchForm.pageNo = 0;
      }

      if (this.order_state == 1) {
        this.searchForm.type = 2;
      } else if (this.order_state == 2) {
        this.searchForm.type = 1;
      }

      var data = _objectSpread({}, this.searchForm);

      var that = this;
      return getExitDrawing(data).then(function (res) {
        if (res.data.code == 0) {
          if (that.order_state == 1) {
            for (var i = 0; i < res.data.info.items.length; i++) {
              var a = res.data.info.items[i].fileUrl.split('.')[res.data.info.items[i].fileUrl.split('.').length - 1];
              res.data.info.items[i].name = res.data.info.items[i].fileUrl.split('/')[res.data.info.items[i].fileUrl.split('/').length - 1].split('-')[res.data.info.items[i].fileUrl.split('/')[res.data.info.items[i].fileUrl.split('/').length - 1].split('-').length - 1];

              if (a == 'pdf') {
                res.data.info.items[i].pic = 2;
              } else if (a == 'jpg') {
                res.data.info.items[i].pic = 1;
              } else if (a == 'png') {
                res.data.info.items[i].pic = 5;
              } else if (a == 'dos') {
                res.data.info.items[i].pic = 0;
              } else if (a == 'rar') {
                res.data.info.items[i].pic = 3;
              } else {
                res.data.info.items[i].pic = 4;
              }
            }

            _this.dataList = res.data.info.items;
          } else {
            for (var _i = 0; _i < res.data.info.items.length; _i++) {
              var _a = res.data.info.items[_i].fileUrl.split('.')[res.data.info.items[_i].fileUrl.split('.').length - 1];

              res.data.info.items[_i].name = res.data.info.items[_i].fileUrl.split('/')[res.data.info.items[_i].fileUrl.split('/').length - 1].split('-')[res.data.info.items[_i].fileUrl.split('/')[res.data.info.items[_i].fileUrl.split('/').length - 1].split('-').length - 1];

              if (_a == 'pdf') {
                res.data.info.items[_i].pic = 2;
              } else if (_a == 'jpg') {
                res.data.info.items[_i].pic = 1;
              } else if (_a == 'png') {
                res.data.info.items[_i].pic = 5;
              } else if (_a == 'dos') {
                res.data.info.items[_i].pic = 0;
              } else if (_a == 'rar') {
                res.data.info.items[_i].pic = 3;
              } else {
                res.data.info.items[_i].pic = 4;
              }
            }

            _this.dataList1 = res.data.info.items;
          }
        }
      });
    },
    pullingDown: function pullingDown() {
      this.loadList(true);
    },
    pullingUp: function pullingUp() {
      this.pageIndex = this.pageIndex + 1;
      this.loadList().then(function () {});
    },
    init: function init() {
      var _this2 = this;

      var code = new URLSearchParams(location.search).get('code') || '';
      var params = {
        code: code,
        pageNo: 0,
        pageSize: 10
      };
      getHdProjectproductGetScrapFile(params).then(function (res) {
        if (res.data.code === 0) {
          for (var i = 0; i < res.data.info.items.length; i++) {
            var a = res.data.info.items[i].fileUrl.split('.')[res.data.info.items[i].fileUrl.split('.').length - 1];
            res.data.info.items[i].name = res.data.info.items[i].fileUrl.split('/')[res.data.info.items[i].fileUrl.split('/').length - 1].split('-')[res.data.info.items[i].fileUrl.split('/')[res.data.info.items[i].fileUrl.split('/').length - 1].split('-').length - 1];

            if (a == 'pdf') {
              res.data.info.items[i].pic = 2;
            } else if (a == 'jpg') {
              res.data.info.items[i].pic = 1;
            } else if (a == 'png') {
              res.data.info.items[i].pic = 5;
            } else if (a == 'dos') {
              res.data.info.items[i].pic = 0;
            } else if (a == 'rar') {
              res.data.info.items[i].pic = 3;
            } else {
              res.data.info.items[i].pic = 4;
            }
          }

          _this2.fileList = res.data.info.items;
        }
      });
      getHdProjectproductGetOperateVideo({
        pageNo: 0,
        pageSize: 999,
        code: this.$router.currentRoute.params.code
      }).then(function (res) {
        if (res.data.code === 0) {
          _this2.videoList = res.data.info.items;
        }
      });
    }
  },
  created: function created() {
    this.init();
    this.loadList(true);
  }
};